import { render, staticRenderFns } from "./imaged-object-results.vue?vue&type=template&id=566d55fb&scoped=true&"
import script from "./imaged-object-results.vue?vue&type=script&lang=ts&"
export * from "./imaged-object-results.vue?vue&type=script&lang=ts&"
import style0 from "./imaged-object-results.vue?vue&type=style&index=0&id=566d55fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d55fb",
  null
  
)

export default component.exports